<template>
  <form class="register-user-type row"
        @submit.prevent="submit">
    <div class="col-md-6">
      <h2>Step 1: Register for an account</h2>
      <div class="register-intro">
        It’s important to select the correct user type at this Step 1,
        in order for your school or organisation to appear in the list at Step 2
      </div>
      <div class="form-group">
        <label :for="$id('email')">
          Email address:
        </label>

        <b-form-input
          :id="$id('email')"
          v-model="internalValue.emailAddress"
          autocomplete="email"
          type="email"
          placeholder="Email address"
          aria-label="Email address">
        </b-form-input>
        <span v-if="showValidation && !internalValue.emailAddress"
              class="validation-error">
          Please enter your email address.
        </span>
      </div>
      <div class="form-group">
        <label :for="$id('userType')">
          User type:
        </label>

        <b-form-select
          :id="$id('userType')"
          v-model="selectedUserTypeId"
          @change="onUserTypeChange">
          <b-form-select-option value="0"
                                selected>
            - Please select -
          </b-form-select-option>
          <b-form-select-option
            v-for="(userType, index) in parentUserTypes"
            :key="index"
            :value="userType.webUserTypeParentId">
            {{ userType.webUserTypeParent }}
          </b-form-select-option>
        </b-form-select>

        <span v-if="showValidation && !selectedUserTypeId"
              class="validation-error">
          Please select a user type.
        </span>
      </div>
    </div>

    <div class="col-12 registration-buttons">
      <button class="btn btn-rounded btn-accent-6"
              type="submit">
        Proceed
      </button>
    </div>
  </form>
</template>

<script>
import { isEqual, cloneDeep } from "lodash";
import { webAccountUserTypeParents } from "~/Scripts/resources/registrationResource";

export default {
  name: "SelectUserType",

  props: {
    /**
     * V-model value
     */
    value: {
      type: Object,
      default: () => ( {
        emailAddress: null,
        userType: {}
      } )
    }
  },

  data () {
    return {
      internalValue: {
        emailAddress: null,
        userType: {}
      },

      selectedUserTypeId: 0,
      parentUserTypes: [],
      showValidation: false
    };
  },

  computed: {
    /**
     * Whether or not the form is valid
     */
    isValid () {
      let result = false;
      if ( this.internalValue.emailAddress && this.selectedUserTypeId ) {
        result = true;
      }
      return result;
    }
  },

  watch: {
    /**
     * Watch for changes to the v-model value
     */
    value: {
      immediate: true,
      deep: true,
      handler ( val ) {
        if ( !isEqual( val, this.internalValue ) ) {
          this.internalValue = cloneDeep( val );
        }
      }
    },

    /**
     * Watch for changes to the internal value
     */
    internalValue: {
      deep: true,
      handler ( val ) {
        this.$emit( "input", val );
      }
    }
  },

  mounted () {
    // Load a list of web account user type parents
    webAccountUserTypeParents()
      .then( result => {
        this.parentUserTypes = result.data || [];
      } )
      .catch( () => {
        this.parentUserTypes = [];
      } );
  },

  methods: {
    /**
     * The form has been submitted
     */
    submit () {
      this.showValidation = true;

      if ( this.isValid ) {
        this.$emit( "proceed" );
      }
    },

    /**
     * The user type has been changd, so update the internal data
     */
    onUserTypeChange () {
      if ( this.parentUserTypes ) {
        this.internalValue.userType = this.parentUserTypes.find(
          x => x.webUserTypeParentId === this.selectedUserTypeId
        );
      }
    }
  }
};
</script>
